export default __webpack_public_path__ + "static/media/vybemedia-logo.c44b458d.png";